<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'OdemeDuzelt',
    props:[
        "data",
    ],
    data() {
        return {
            form: {},
            submitted: false,
        };
    }, 
    watch:{
        data(props){
            const { balance, id, borc, collect, commission, main_explaine } = props
            this.form = { balance, id, borc, collect, commission, main_explaine  }
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('odeme_duzelt')
        },
        handleSubmit(){
            this.$http.put(`/dealers/duzelt`, this.form )
                    .then(resp => {
                        notify.success(resp.data.message)
                        this.$emit('loadItems');
                    })
        }
    },
};
</script>

<template>
<b-modal id="odeme_duzelt"  title="Ödeme Düzelt"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
       <div class="row d-flex flex-wrap mb-1" v-if="form.commission || form.borc">
            <label class="col-sm-5 col-form-label col-form-label" for="borc">
                <span>Borç</span>
            </label>
            <div class="col">
                <input
                id="borc" 
                v-model="form.borc"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.commission || form.borc">
            <label class="col-sm-5 col-form-label col-form-label" for="commission">
                <span>Komisyon</span>
            </label>
            <div class="col">
                <input
                id="commission" 
                v-model="form.commission"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.collect">
            <label class="col-sm-5 col-form-label col-form-label" for="collect">
                <span>Tahsilat</span>
            </label>
            <div class="col">
                <input
                id="collect" 
                v-model="form.collect"
                type="text"
                class="form-control"
                />
          </div>
        </div>
         <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="main_explaine">Açıklama</label>
            <div class="col">
                <input
                id="main_explaine" 
                v-model="form.main_explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Kaydet
            </b-button>
        </div>
    </form>
</b-modal>
</template>